module.exports = __webpack_public_path__ + "media/images/press_kit/aman_at_sea/email/main-white-4b0dd702091a164ab0bbacf1670287fa.png";